<template>
    <div class="arrows">
        <div class="arrow_left" @click="beforeRoute">
            <!-- <img v-if="activeBefore" src="/img/icons/report_arrow_left_active.png" class="active" alt="Seta indicando próxima página">
            <img v-else src="/img/icons/report_arrow_left.png" alt="Seta indicando próxima página"> -->
            <Arrow class="arrow-svg" v-if="activeBefore" :fill="colors.theme == 'dark' ? '#fff' : '#000'"></Arrow>
            <Arrow v-else class="arrow-svg" fill="#3c464e"></Arrow>
        </div>
        <div class="arrow_right" @click="nextRoute">
            <Arrow class="arrow-svg" v-if="activeNext" :fill="colors.theme == 'dark' ? '#fff' : '#000'"></Arrow>
            <Arrow v-else class="arrow-svg" fill="#3c464e"></Arrow>            
            <!-- <img v-if="activeNext" src="/img/icons/report_arrow_right_active.png" class="active" alt="Seta indicando página anterior">
            <img v-else src="/img/icons/report_arrow_right.png" alt="Seta indicando página anterior"> -->
        </div>
    </div>
</template>

<script>
import Arrow from '../customIcons/report/Arrow'
export default {
    name: 'ReportPagination',
    props:['activeBefore', 'activeNext', 'nextRoutePagination', 'beforeRoutePagination'],
    components: {Arrow},
    data: function(){
        return{
            gupyService: JSON.parse(localStorage.getItem("gupyService")),
            cieersInfo: JSON.parse(localStorage.getItem("cieersInfo")),
            colors:{}
        }
    },

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },

    methods:{
        beforeRoute(){
            if(this.beforeRoutePagination) this.$router.push(this.beforeRoutePagination)
        },
        nextRoute(){
            if(this.gupyService && this.beforeRoutePagination == "graphic") return window.location.replace(this.gupyService.callback_url)
            if(this.cieersInfo && this.beforeRoutePagination == "graphic") return window.location.replace(this.cieersInfo.callbackUrl)
            if(this.nextRoutePagination) this.$router.push(this.nextRoutePagination)
        },
    }
}
</script>

<style lang="scss" scoped>
.arrows{
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    top: calc( 50vh - 40px);
    z-index: 50;
    .arrow_right, .arrow_left{
        padding: 0 15px;

    }
    .arrow-svg{
        width: 13px;
    }
    .arrow_left{
        transform: rotate(180deg);
    }
    .active{
        &:hover{
            cursor: pointer;
        }
    }

    img{
        max-width: 23px;
    }
}
</style>
